import { AppService } from "../app.service";
import { PremierServiceExecutionDTO } from "../DTO/premierServiceExecutionDTO";

export class PremierServiceExecution{
    public serviceConfigurationId!: number;
    public startedAt!: Date;
    public finishedAt!: Date;
    public configurationName!: string;
    public productName!: string;
    public customerId!: number;
    public clientId!: number;
    public status!: number;
    public message!: string;
    public remarks!: string;
    public clientName!: string;
    public recurring!: boolean;
    public optionalParameters!: OptionalParameter[];
    public addedByUserId!: number;
    public referenceValues!: string; //Comma separated reference values (like batch IDs, payroll IDs, etc.)

    public static mapFromDTO(param:PremierServiceExecutionDTO):PremierServiceExecution{
        if(!param) throw new Error("parameter is null")
        let obj = new PremierServiceExecution();
        try
        {
            obj.serviceConfigurationId = param.serviceConfigurationId;
            if(param.startedAt)obj.startedAt = new Date(param.startedAt);
            if(param.finishedAt)obj.finishedAt = new Date(param.finishedAt);
            obj.configurationName = param.configurationName;
            obj.productName = param.productName;
            obj.customerId = param.customerId;
            obj.clientId = param.clientId;
            obj.status = param.status;
            obj.message = param.message;
            obj.remarks = param.remarks;
            obj.recurring = param.recurring;
            if(param.optionalParameters){
                let jsonArray:Array<any>=JSON.parse(param.optionalParameters);
                obj.optionalParameters = jsonArray.map(obj=>{let op=new OptionalParameter(); op.name=obj.name; op.value=obj.value; return op;});
            }
            obj.addedByUserId = param.addedByUserId;
            obj.referenceValues = param.referenceValues;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:PremierServiceExecution):PremierServiceExecutionDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new PremierServiceExecutionDTO();
        try 
        {
            dto.serviceConfigurationId = param.serviceConfigurationId;
            if(param.startedAt)dto.startedAt = param.startedAt.toISOString();
            if(param.finishedAt)dto.finishedAt = param.finishedAt.toISOString();
            dto.configurationName = param.configurationName;
            dto.productName = param.productName;
            dto.customerId = param.customerId;
            dto.clientId = param.clientId;
            dto.status = param.status;
            dto.message = param.message;
            dto.remarks = param.remarks;
            dto.recurring = param.recurring;
            if(param.optionalParameters) dto.optionalParameters = JSON.stringify(param.optionalParameters);
            dto.addedByUserId = param.addedByUserId;
            dto.referenceValues = param.referenceValues;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 1:
                return "In Process";
            case 2:
                return "Success";
            case 3:
                return "Error"
            default:
                return "";
        }
    }

    get statusColor(){
        switch(this.status){
            case 3:
                return "red";
            default:
                return "black";
        }
    }

    get creation(){
        return this.recurring?'Scheduled':'Manual';
    }

    get batchPayrollIds(){
        let op = this.optionalParameters?.find(op=> AppService.allPremierPartnerOptionalParameterListNames.includes(op.name));
        if(op?.value) return op.value;
        if(this.recurring && this.referenceValues) return this.referenceValues;
        return "None";
    }

    get processedOnError(){
        if(this.recurring) return "N/A";
        let op = this.optionalParameters?.find(op=> op.name=="processedOnError");
        if(!op?.value) return "N/A";
        if(op.value === "true") return "True";
        if(op.value === "false") return "False";
        return op.value;
    }

}

export class OptionalParameter{
    public name!: string;
    public value!: string;
}


